import type { Node as ProsemirrorNode, NodeSpec } from 'prosemirror-model';

import { CheckboxStyles, ChecklistItemStyles } from './checklist-styles';
import { NodeName } from '../../../schema/nodes';
import type { ProsemirrorAttrs } from '../../../schema/schema';

export const updateChecklistItem = (li: HTMLElement, checkbox: HTMLElement, checked: boolean) => {
  li.setAttribute('data-checked', `${checked}`);

  Object.assign(li.style, checked ? ChecklistItemStyles.checked : ChecklistItemStyles.notChecked);
  Object.assign(checkbox.style, {
    ...CheckboxStyles.base,
    ...(checked ? CheckboxStyles.getCheckedStyles() : CheckboxStyles.notChecked),
  });
};

const ZERO_WIDTH_SPACE = '\u200b';
export const createCheckListNode = (document: Document, node: ProsemirrorNode) => {
  const li = document.createElement('li');
  const checkboxContainer = document.createElement('div');
  const checkbox = document.createElement('div');
  const content = document.createElement('div');
  checkbox.classList.add('rt-pm-checkbox');
  li.setAttribute('data-component-type', 'checklist-item');
  checkboxContainer.append(ZERO_WIDTH_SPACE, checkbox);
  li.append(checkboxContainer, content);
  Object.assign(checkboxContainer.style, CheckboxStyles.getContainerStyles());
  Object.assign(li.style, ChecklistItemStyles.base);

  const checked = node.attrs['checked'];
  updateChecklistItem(li, checkbox, checked);

  return {
    dom: li,
    contentDOM: content,
    checkbox,
  };
};

export interface ChecklistItemAttrs {
  checked: boolean;
}

export class ChecklistItemNode implements NodeSpec {
  public static readonly nodeName = NodeName.ChecklistItem;
  public static is(node: ProsemirrorNode) {
    return node.type.name === ChecklistItemNode.nodeName;
  }
  public static isChecked(node: ProsemirrorNode) {
    return (<ChecklistItemAttrs>node.attrs).checked;
  }

  public defining = true;
  public content = 'paragraph block*';
  public attrs: ProsemirrorAttrs<ChecklistItemAttrs> = {
    checked: { default: false },
  };
  public parseDOM = [
    {
      tag: 'li[data-component-type="checklist-item"]',
      getAttrs: (node: HTMLElement) =>
        <ChecklistItemAttrs>{ checked: node.dataset['checked'] === 'true' },
      contentElement: (node: HTMLElement) => <HTMLElement>node.children[1],
    },
  ];

  constructor(
    private document: Document,
    checklistViewOnly: boolean,
  ) {
    if (checklistViewOnly) {
      this.parseDOM = [];
    }
  }

  public toDOM = (node: ProsemirrorNode) => createCheckListNode(this.document, node);
}
